<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="display: flex;width:100%">
            <div style="margin-top: 10px;text-align: center;width:100%">
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1974]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.year" type="text" size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[1975]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.month"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <!--<td>
                                <span style="color:red">执行状态：{{btn.execute == false?"执行中...":"未执行"}}</span>
                            </td>-->
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" style="margin-top: 5px;" v-model="activeName" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[7479]')" name="0" id="xpane-0">
                        <div style="text-align: left">
                            <el-button type="primary" size="mini" @click="search">{{$t('getapi[1980]')}}</el-button>
                            <el-input v-model="keyzz" class="input-with-select" style="width:250px;margin-left:8px">
                                <el-button slot="append" icon="el-icon-search" @click="positionzz"></el-button>
                            </el-input>
                            <el-button type="primary" size="mini" @click="delzz" :disabled="selectDatazz.length == 0" style="margin-left:8px">{{$t('getapi[3889]')}}</el-button>
                            <el-button type="primary" size="mini" @click="exec" :disabled="!btn.execute">{{$t('getapi[5063]')}}</el-button>
                            <el-button type="primary" size="mini" @click="exp">{{$t('getapi[922]')}}</el-button>
                        </div>
                        <vxe-table
                                ref="singleTablezz"
                                :data="datazz"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                resizable
                                size="mini"
                                :height="tableHeight"
                                header-row-class-name="headerclass"
                                show-overflow="tooltip"
                                style="width: 100%; margin-top:0px"
                                :auto-resize="true"
                                :row-class-name="tableRowClassNamezz"
                                @checkbox-change="handleSelectionChangezz"
                                @checkbox-all="handleSelectionChangeAllzz"
                                @checkbox-range-end="handleSelectionChangezz"
                                :checkbox-config="{highlight: true, range: true}"
                                :mouse-config="{selected:true, extension: true}"
                        >
                            <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="line_no" :title="$t('getapi[1297]')" width="60"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="so_code" :title="$t('getapi[4285]')" width="120"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width="160"></vxe-table-column>
                           <!-- <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width="80"></vxe-table-column>-->
                            <vxe-table-column field="Plan_Finish_qty" :title="$t('getapi[6298]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Plan_Finish_qty | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="scrap_qty" :title="$t('getapi[4220]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.scrap_qty | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="rework_qty" :title="$t('getapi[4906]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.rework_qty | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Schedule_No" :title="$t('getapi[4209]')" width="160"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Force_Close_Flag" :title="$t('getapi[2345]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Force_Close_Reason" :title="$t('getapi[2337]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Create_Time" :title="$t('getapi[3672]')" width="100"></vxe-table-column>
                            <vxe-table-column field="cost" :title="$t('getapi[7479]')" width="100" align="right">
                                <template slot-scope="scope">
                                    {{ scope.row.cost | thousandth}}
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7480]')" name="1" id="xpane-1">
                        <div style="text-align: left">
                            <el-button type="primary" size="mini" @click="search">{{$t('getapi[1980]')}}</el-button>
                            <el-input v-model="keyck" class="input-with-select" style="width:250px;margin-left:8px">
                                <el-button slot="append" icon="el-icon-search" @click="positionck"></el-button>
                            </el-input>
                            <el-button type="primary" size="mini" @click="delck" :disabled="selectDatack.length == 0" style="margin-left:8px">{{$t('getapi[3889]')}}</el-button>
                            <el-button type="primary" size="mini" @click="exec" :disabled="!btn.execute">{{$t('getapi[5063]')}}</el-button>
                            <el-button type="primary" size="mini" @click="exp">{{$t('getapi[922]')}}</el-button>
                        </div>
                        <vxe-table
                                ref="singleTableck"
                                :data="datack"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                resizable
                                size="mini"
                                :height="tableHeight"
                                header-row-class-name="headerclass"
                                show-overflow="tooltip"
                                style="width: 100%; margin-top:0px"
                                :row-class-name="tableRowClassNameck"
                                @checkbox-change="handleSelectionChangeck"
                                @checkbox-all="handleSelectionChangeAllck"
                                @checkbox-range-end="handleSelectionChangeck"
                                :checkbox-config="{highlight: true, range: true}"
                                :mouse-config="{selected:true, extension: true}"
                        >
                            <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="category_first" :title="$t('getapi[169]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="category_second" :title="$t('getapi[170]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="category_third" :title="$t('getapi[171]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Order_No" :title="$t('getapi[2206]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Line_no" :title="$t('getapi[3868]')" width="150"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="cost_year" :title="$t('getapi[4987]')" width="80"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="cost_month" :title="$t('getapi[4988]')" width="80"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="digest" :title="$t('getapi[7340]')" width="80"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Customer_code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                            <vxe-table-column field="Issue_Material_Amount" :title="$t('getapi[7481]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Issue_Material_Amount | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="Issue_Man_Amount" :title="$t('getapi[7482]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Issue_Man_Amount | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="Issue_Charge_Amount" :title="$t('getapi[7483]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Issue_Charge_Amount | thousandth}}
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[13122]')" name="2" id="xpane-2">
                        <div style="text-align: left">
                            <el-button type="primary" size="mini" @click="search">{{$t('getapi[1980]')}}</el-button>
                            <el-input v-model="keyck" class="input-with-select" style="width:250px;margin-left:8px">
                                <el-button slot="append" icon="el-icon-search" @click="positionhh"></el-button>
                            </el-input>
                            <el-button type="primary" size="mini" @click="delhh" :disabled="selectDatahh.length == 0" style="margin-left:8px">{{$t('getapi[3889]')}}</el-button>
                            <el-button type="primary" size="mini" @click="exec" :disabled="!btn.execute">{{$t('getapi[5063]')}}</el-button>
                            <el-button type="primary" size="mini" @click="exp">{{$t('getapi[922]')}}</el-button>
                        </div>
                        <vxe-table
                                ref="singleTablehh"
                                :data="datahh"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                resizable
                                size="mini"
                                :height="tableHeight"
                                header-row-class-name="headerclass"
                                show-overflow="tooltip"
                                style="width: 100%; margin-top:0px"
                                :row-class-name="tableRowClassNamehh"
                                @checkbox-change="handleSelectionChangehh"
                                @checkbox-all="handleSelectionChangeAllhh"
                                @checkbox-range-end="handleSelectionChangehh"
                                :checkbox-config="{highlight: true, range: true}"
                                :mouse-config="{selected:true, extension: true}"
                        >
                            <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="category_first" :title="$t('getapi[169]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="category_second" :title="$t('getapi[170]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="category_third" :title="$t('getapi[171]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Order_No" :title="$t('getapi[2206]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Line_no" :title="$t('getapi[3868]')" width="150"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="cost_year" :title="$t('getapi[4987]')" width="80"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="cost_month" :title="$t('getapi[4988]')" width="80"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="new_part_code" :title="$t('getapi[13106]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="new_part_version" :title="$t('getapi[13107]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="digest" :title="$t('getapi[7340]')" width="80"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')" width="100"></vxe-table-column>
                            <vxe-table-column show-overflow-tooltip field="Customer_code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                            <vxe-table-column field="Issue_Material_Amount" :title="$t('getapi[7481]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Issue_Material_Amount | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="Issue_Man_Amount" :title="$t('getapi[7482]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Issue_Man_Amount | thousandth}}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="Issue_Charge_Amount" :title="$t('getapi[7483]')" align="right" width="100">
                                <template slot-scope="scope">
                                    {{ scope.row.Issue_Charge_Amount | thousandth}}
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
                <!--<div style="margin-top: 10px">
                    <el-button type="primary" @click="execute(0)" :disabled="!btn.execute">执行</el-button>
                </div>-->
            </div>

            <el-dialog v-dialogDrag :visible.sync="visShowMessage"  width="30%" :close-on-click-modal="false">
                <div style="text-align:	center;margin-top: 15px"><el-input v-model="textareaShowMessage" type="textarea" rows="10"></el-input></div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="visShowMessage = false">{{ $t('getapi[2054]') }}</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_updatepparth',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-220
            }
        },
        data() {
            return {
                btn: {
                    execute: true,
                },
                dataDetail:{
                    year: '',
                    month: ''
                },
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                visShowMessage: false,
                textareaShowMessage: '',
                activeName:'0',
                datazz: [], // 在制成本
                datack: [], // 出库成本
                datahh: [], //材料出库换号
                loading: false,
                selectDatazz: [],
                selectDatack: [],
                selectDatahh: [],
                keyzz: '',
                keyck: '',
                keyhh: '',
                SelectIndex: 0,
                scrollTop:0,
            };
        },
        beforeDestroy(){
        },
        mounted: function () {
            let that = this;
            that.dataDetail.year = new Date().getFullYear()
            that.dataDetail.month = new Date().getMonth() + 1
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTablezz.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTablezz.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6675]"),this.$t("getapi[6633]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            tableRowClassNamezz({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameck({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNamehh({row, rowIndex}) {
                row.index = rowIndex;
            },
            selectInfo(tab, event) {
                let that = this;
                that.activeName = tab.name;
                that.SelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            // 执行
            execute(val){
                let that = this
                that.$confirm(that.$t('getapi[8596]'), that.$t('getapi[194]'), {//'确定要执行嘛'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let that = this
                        let parm = {
                            TYear: that.dataDetail.year,
                            Month: that.dataDetail.month
                        }
                        that.btn.execute = false
                        that.$http.urlpost('/Fin/Wip/FinUpdateP_Parth', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                if(res.PopupTxt != ''){
                                    that.visShowMessage = true;
                                    that.textareaShowMessage = res.PopupTxt
                                }
                            }
                            that.btn.execute = true
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            //查询
            search(){
                let that = this
                if(that.activeName == 0){
                    let parm = {
                        TYear: that.dataDetail.year,
                        Month: that.dataDetail.month
                    }
                    that.loading = true
                    that.$http.urlpost('/Fin/Wip/GetFinSoDeadCostCarray', parm, function (res) {
                        if (res.Success == 1) {
                           that.datazz = res.DataContent
                            that.selectDatazz = []
                            that.$nextTick(function(){
                                setTimeout(() => {
                                    that.$processdata.initForm(that.SelectIndex)
                                }, 500);
                            });
                        }
                        that.loading = false
                    });
                } else if(that.activeName == 1) {
                    let parm = {
                        TYear: that.dataDetail.year,
                        Month: that.dataDetail.month
                    }
                    that.loading = true
                    that.$http.urlpost('/Fin/Wip/GetFinIssueCostCarray', parm, function (res) {
                        if (res.Success == 1) {
                            that.datack = res.DataContent
                            that.selectDatack = []
                            that.$nextTick(function(){
                                setTimeout(() => {
                                    that.$processdata.initForm(that.SelectIndex)
                                }, 500);
                            });
                        }
                        that.loading = false
                    });
                } else if(that.activeName == 2){
                    let parm = {
                        TYear: that.dataDetail.year,
                        Month: that.dataDetail.month
                    }
                    that.loading = true
                    that.$http.urlpost('Fin/Wip/GetFinIssueCostCarrayChange', parm, function (res) {
                        if (res.Success == 1) {
                            that.datahh = res.DataContent
                            that.selectDatahh = []
                            that.$nextTick(function(){
                                setTimeout(() => {
                                    that.$processdata.initForm(that.SelectIndex)
                                }, 500);
                            });
                        }
                        that.loading = false
                    });
                }
            },
            exec(){
                let that = this
                that.$confirm(that.$t('getapi[8596]'), that.$t('getapi[194]'), {//'确定要执行嘛'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(that.activeName == 0){
                            let arr = []
                            for(let i = 0;i<that.datazz.length;i++){
                                arr = [...arr,{
                                    so_code: that.datazz[i].so_code,
                                }]
                            }
                            let parm = {
                                costyear: that.dataDetail.year,
                                costmonth: that.dataDetail.month,
                                ls: arr,
                                LangType: that.$processdata.getLang(),
                            }
                            that.btn.execute = false
                            let loadingInstance = Loading.service(Common.maskoption1);
                            that.$http.urlpost('/Fin/Wip/FinSoDeadCostCarray', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    if(res.PopupTxt != ''){
                                        that.visShowMessage = true;
                                        that.textareaShowMessage = res.PopupTxt
                                    }
                                }
                                that.btn.execute = true
                                loadingInstance.close()
                            });
                        }else if(that.activeName == 1){
                            let arr = []
                            for(let i = 0;i<that.datack.length;i++){
                                arr = [...arr,{
                                    digest: that.datack[i].digest,
                                    order_no: that.datack[i].Order_No,
                                    line_no: that.datack[i].Line_no,
                                    part_code: that.datack[i].part_code,
                                    part_version: that.datack[i].part_version
                                }]
                            }
                            let parm = {
                                costyear: that.dataDetail.year,
                                costmonth: that.dataDetail.month,
                                ls: arr,
                                LangType: that.$processdata.getLang(),
                            }
                            that.btn.execute = false
                            let loadingInstance = Loading.service(Common.maskoption1);
                            that.$http.urlpost('/Fin/Wip/FinIssueCostCarray', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    if(res.PopupTxt != ''){
                                        that.visShowMessage = true;
                                        that.textareaShowMessage = res.PopupTxt
                                    }
                                }
                                that.btn.execute = true
                                loadingInstance.close()
                            });
                        }else if(that.activeName == 2){
                            let arr = []
                            for(let i = 0;i<that.datahh.length;i++){
                                arr = [...arr,{
                                    digest: that.datahh[i].digest,
                                    order_no: that.datahh[i].Order_No,
                                    line_no: that.datahh[i].Line_no,
                                    part_code: that.datahh[i].part_code,
                                    part_version: that.datahh[i].part_version
                                }]
                            }
                            let parm = {
                                costyear: that.dataDetail.year,
                                costmonth: that.dataDetail.month,
                                ls: arr,
                                LangType: that.$processdata.getLang(),
                            }
                            that.btn.execute = false
                            let loadingInstance = Loading.service(Common.maskoption1);
                            that.$http.urlpost('Fin/Wip/FinIssueCostCarrayChange', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                    if(res.PopupTxt != ''){
                                        that.visShowMessage = true;
                                        that.textareaShowMessage = res.PopupTxt
                                    }
                                }
                                that.btn.execute = true
                                loadingInstance.close()
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 多选
            handleSelectionChangezz({checked, records }) {
                let that = this;
                that.selectDatazz = records;
            },
            handleSelectionChangeAllzz({ records }){
                let that = this;
                that.selectDatazz = records;
            },
            handleSelectionChangeck({checked, records }) {
                let that = this;
                that.selectDatack = records;
            },
            handleSelectionChangeAllck({ records }){
                let that = this;
                that.selectDatack = records;
            },
            handleSelectionChangehh({checked, records }) {
                let that = this;
                that.selectDatahh = records;
            },
            handleSelectionChangeAllhh({ records }){
                let that = this;
                that.selectDatahh = records;
            },
            delzz(){
                let that = this
                that.$confirm(that.$t('getapi[8608]'), that.$t('getapi[194]'), {//确定要删除嘛
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = that.selectDatazz.length - 1; i >= 0; i--) {
                            that.datazz.splice(that.selectDatazz[i].index, 1);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            delck(){
                let that = this
                that.$confirm(that.$t('getapi[8608]'), that.$t('getapi[194]'), {//确定要删除嘛
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = that.selectDatack.length - 1; i >= 0; i--) {
                            that.datack.splice(that.selectDatack[i].index, 1);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            delhh(){
                let that = this
                that.$confirm(that.$t('getapi[8608]'), that.$t('getapi[194]'), {//确定要删除嘛
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = that.selectDatahh.length - 1; i >= 0; i--) {
                            that.datack.splice(that.selectDatahh[i].index, 1);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            positionzz(){
                let that = this
                if(that.keyzz == ''){
                    return
                }
                let row = null
                let index = 0
                for(let i =0;i<that.datazz.length;i++){
                    if(that.keyzz.toUpperCase() == that.datazz[i].so_code.toUpperCase() || that.keyzz.toUpperCase() == that.datazz[i].part_code.toUpperCase()){
                        row = that.datazz[i]
                        index = i
                        break
                    }
                }
                if(row != null){
                    that.$refs.singleTablezz.setCurrentRow(row);
                    setTimeout(() => {
                        setTimeout(() => {
                            that.$refs.singleTablezz.clearScroll().then(() => {
                                this.$refs.singleTablezz.scrollTo(0, (24*index))
                            })
                        }, 200);
                    }, 0);
                }
            },
            positionck(){
                let that = this
                if(that.keyck == ''){
                    return
                }
                let row = null
                let index = 0
                for(let i =0;i<that.datack.length;i++){
                    if(that.keyck.toUpperCase() == that.datack[i].Order_No.toUpperCase() || that.keyck.toUpperCase() == that.datack[i].part_code.toUpperCase()){
                        row = that.datack[i]
                        index = i
                        break
                    }
                }
                if(row != null){
                    that.$refs.singleTableck.setCurrentRow(row);
                    setTimeout(() => {
                        setTimeout(() => {
                            that.$refs.singleTableck.clearScroll().then(() => {
                                this.$refs.singleTableck.scrollTo(0, (24*index))
                            })
                        }, 200);
                    }, 0);
                }
            },
            positionhh(){
                let that = this
                if(that.keyhh == ''){
                    return
                }
                let row = null
                let index = 0
                for(let i =0;i<that.datahh.length;i++){
                    if(that.keyhh.toUpperCase() == that.datahh[i].Order_No.toUpperCase() || that.keyhh.toUpperCase() == that.datahh[i].part_code.toUpperCase()){
                        row = that.datahh[i]
                        index = i
                        break
                    }
                }
                if(row != null){
                    that.$refs.singleTablehh.setCurrentRow(row);
                    setTimeout(() => {
                        setTimeout(() => {
                            that.$refs.singleTableck.clearScroll().then(() => {
                                this.$refs.singleTableck.scrollTo(0, (24*index))
                            })
                        }, 200);
                    }, 0);
                }
            },
            exp(){
                let that = this
                if(that.activeName == 0){
                    let parm = {
                        costyear: that.dataDetail.year,
                        costmonth: that.dataDetail.month,
                        ls: that.datazz
                    }
                    that.$http.urlpost('/Fin/Wip/FinSoDeadCostCarrayToExecl', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                    });
                } else if(that.activeName == 1){
                    let parm = {
                        costyear: that.dataDetail.year,
                        costmonth: that.dataDetail.month,
                        ls: that.datack
                    }
                    that.$http.urlpost('/Fin/Wip/FinIssueCostCarrayToExecl', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                    });
                } else if(that.activeName == 2){
                    let parm = {
                        costyear: that.dataDetail.year,
                        costmonth: that.dataDetail.month,
                        ls: that.datahh
                    }
                    that.$http.urlpost('Fin/Wip/FinIssueCostCarrayChangeToExecl', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
